import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.988}
    height={25.989}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24482 24482"
    {...props}
  >
    <path
      d="M22982 5543 8103 20422l-1283-1282L21589 4371c197-197 306-459 306-739 0-921-1123-1397-1783-738L5343 17663l-1283-1283L18940 1500c539-540 1257-837 2021-837 1580 0 2858 1278 2858 2859 0 763-297 1481-837 2021zM7100 21424l-4042-4042 630-630 4042 4043-630 629zm-1532 1533c-1395-1396-3252-3253-4042-4043l1159-1159 4042 4042-1159 1160zm147-4922L20484 3266c202-202 531-202 733 0 203 203 202 531 0 733L6448 18768l-733-733zM23354 1128c-1323-1323-3464-1323-4787 0C-754 20449 2079 17617 968 18728c-103 103-103 270 0 372l743 744-1498 1498c-167 167-46 449 186 449 67 0 135-26 186-77l1498-1498 2184 2183-1499 1498c-166 167-45 450 186 450 68 0 135-26 186-77l1499-1499 743 744c103 103 270 103 372 0L23354 5915c1323-1323 1323-3464 0-4787z"
      style={{
        fill: "#2b2a29",
        // stroke: "#000",
        strokeWidth: 271.307,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
